module.exports = __webpack_public_path__ + "static/media/selfwork.96aa07cf.jpg";